export default {
  salidas: [],
  selectedSalida: null,
  error: false,
  errorMessage: [],
}
